import { useCallback } from 'react';
import { rage, useObservable } from '~/rage';
import { ModalButtonColor, ModalType, WalletType } from '~/shared';

const useRepair = () => {
	const engineRepairPrice = useObservable(
		rage.vehicleServiceStation.getEngineRepairPrice(),
	);

	const handleRepair = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.Price,
				title: 'Подтверждение',
				text: 'Вы действительно хотите сделать кап. ремонт двигателя?',
				price: engineRepairPrice,
				wallet: WalletType.Cash,
				acceptButton: { text: 'Оплатить', color: ModalButtonColor.Success },
				cancelButton: {
					text: 'Отменить',
					color: ModalButtonColor.Secondary,
				},
			},
			(result) => {
				if (result.isAccepted) {
					rage.vehicleServiceStation.repairEngine();
				}
			},
		);
	}, [engineRepairPrice]);

	return { handleRepair };
};

export { useRepair };
